import Cookies from "js-cookie";

const CSRF_KEY = "cuo_csrf_token";

// Firebase Hosting strips every cookie except __session on the way to Cloud Run, so
// Django runs with CSRF_USE_SESSIONS and hands the token back from auth/login/ instead
// of setting a csrftoken cookie. The cookie read stays as a fallback.
export function getCsrfToken(): string {
  return localStorage.getItem(CSRF_KEY) ?? Cookies.get("csrftoken") ?? "";
}

export function setCsrfToken(token: string | undefined) {
  if (token) localStorage.setItem(CSRF_KEY, token);
}

export function clearCsrfToken() {
  localStorage.removeItem(CSRF_KEY);
}
